import { createTheme } from '@material-ui/core/styles';

export const cryptobroadwayTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#254189',
    },
    secondary: {
      main: '#e4e4e4',
    },
    highlight: {
      main: '#ffd94d'
    },
    background: {
      default: '#fffdfb',
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: 'Lexend, Helvetica, Arial, cursive',
    button: {
      textTransform: 'none',
      fontWeight: 700,
      fontSize: 16
    },
  },
  props: {
    // Name of the component ⚛️
    MuiButtonButton: {
      // The properties to apply
      focusRipple: false, // No more ripple, on the whole application 💣!
    },
  },
});
